<script lang="ts" context="module">
export type SortDir = "asc" | "desc";
</script>

<script lang="ts">
export let data:    any[] = [];
export let sortKey: string | undefined;
export let sortDir: SortDir | undefined;

let defaultSortDir: SortDir = sortDir || "asc";

function get (path: string | string[], object: any): any {
	if (typeof path === "string") {
		path = path.split(".");
	}
	let key = path.shift();

	if (object.hasOwnProperty(key)) {
		if (path.length) {
			return get(path, object[key]);
		}
		return object[key];
	}

	return undefined;
}

function sort (arr: any[], key?: string, dir?: SortDir) {
	if (!key) {
		return [...arr];
	}
	return [...arr].sort((a, b) => {
		a = get(key, a);
		b = get(key, b);

		if (a === b) {
			return 0;
		}
		if (dir === "asc") {
			return a > b ? 1 : -1;
		} else {
			return a < b ? 1 : -1;
		}
	});
};
$: sorted = sort(data, sortKey, sortDir);

export function sortBy (key?: string, defaultDir?: SortDir) {
	if (!key) {
		sortKey = undefined;
		return;
	}
	if (key !== sortKey) {
		sortKey = key;
		sortDir = defaultDir || defaultSortDir;
		return;
	}

	sortDir = sortDir === "asc" ? "desc" : "asc";
}

export function isActive (key: string) {
	return sortKey === key;
}
</script>

<slot {sorted} {sortKey} {sortDir} {sortBy} {isActive}>
</slot>
